<div class="header">
  <h2 mat-dialog-title>{{data.title}}</h2>
</div>

<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>

<div mat-dialog-actions [align]="'end'">
  <button class="btn-success" [mat-dialog-close]="true">
    {{data.confirmCaption}}
  </button>
</div>
